module.exports = __webpack_public_path__ + "ferestre-bg.jpg?148f123482706f69053fda0fb02ec0cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ferestre-bg.jpg
// module id = 140
// module chunks = 0